<template>
  <header>
    <h1 class="header_logo"><router-link to="/"><img src="../../assets/img/common/header/logo.png" width="184" alt="テレビ朝日映像株式会社" /></router-link></h1><!-- .header_logo -->
    <div id="header_navbox">
      <nav id="g_nav">
        <ul id="g_nav_list">
          <li>
            <router-link to="/news"><img src="../../assets/img/common/header/nav_news.png"  width="87" alt="NEWS" /></router-link>
          </li>
          <li>
            <router-link to="/players"><img src="../../assets/img/common/header/nav_player.png"  width="127" alt="players" /></router-link>
          </li>
          <li>
            <router-link to="/works"><img src="../../assets/img/common/header/nav_works.png"  width="111" alt="WORKS" /></router-link>
          </li>
          <li>
            <router-link to="/company"><img src="../../assets/img/common/header/nav_company.png"  width="150" alt="COMPANY" /></router-link>
          </li>
          <li>
            <router-link to="/recruit"><img src="../../assets/img/common/header/nav_recruit.png"  width="132" alt="RECRUIT" /></router-link>
          </li>
          <li class="tapcast_end">
            <router-link to="/tapcast">TAP CAST 終了のお知らせ</router-link>
          </li>
        </ul>
        <div id="g_nav_sns">
          <p class="youtube"><a href="#"><img src="../../assets/img/common/header/youtube.png"  width="97" alt="Youtube" /></a></p>
          <div class="share_box">
            <ul class="share_box_list">
              <li class="instagram"><a href="https://www.instagram.com/tv_asahipro_saiyo/" target="_blank"><img src="../../assets/img/common/header/sns_i.png" width="116" alt="Instagram" /></a></li>
              <li><a href="#"><img src="../../assets/img/common/header/share_title.png" width="56" alt="SHARE" /></a></li>
              <li class="sns_icon"><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u=' + current_url " target="_blank"><img src="../../assets/img/common/header/sns_f.png" width="22" alt="Facebook" /></a></li>
              <li class="sns_icon"><a v-bind:href="'http://twitter.com/share?url=' + current_url " target="_blank"><img src="../../assets/img/common/header/sns_t.png" width="31" alt="Twitter" /></a></li>
            </ul>
          </div><!-- .share_box -->
        </div><!-- #gnav_sns -->
      </nav><!-- #g_nav -->
    </div><!-- #header_navbox -->
    <div id="sp_menu">
      <a class="sp_menu_box" href="">
        <span></span>
        <span></span>
        <span></span>
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'headerItem',
  data (){
    return {
      current_url: location.origin
    }
  },
  mounted () {
    var header = document.getElementsByTagName('header');
    if (this.recruit_check()){
      $(header).css('display', 'none');
    }else{
      $(header).css('display', 'block');
    }
    this.body_color()
  },
  watch: {
    '$route' (to, from) {
      var header = document.getElementsByTagName('header');
      if (this.recruit_check()){
        $(header).css('display', 'none');
      }else{
        $(header).css('display', 'block');
      }
      this.body_color()
    }
  },
  methods: {
    recruit_check(){
      return ['recruit_2021','recruit_2022','recruit_2023','recruit_2024','recruit_2025','recruit_2025_application','recruit_2025_teaser','recruit_2025_top','recruit_2026','recruit_2026_application','recruit_2026_top'].includes(this.$route.name)
    },
    body_color(){
      if(this.$route.name == 'recruit_2025' || this.$route.name == 'recruit_2025_application' || this.$route.name == 'recruit_2025_teaser' || this.$route.name == 'recruit_2025_top' || this.$route.name == 'recruit_2026' || this.$route.name == 'recruit_2026_application' || this.$route.name == 'recruit_2026_top'){
        $("meta[name ='theme-color']").attr('content','#000');
        $("body").css('background','#000');
      } else {
        $("meta[name ='theme-color']").attr('content','#FFF');
        $("body").css('background','#FFF');
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/headerItem.vue